module.exports = __webpack_public_path__ + "img/chart-active.8d353674.svg";